var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckList2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512.694 512.694",
    height: 512,
    viewBox: "0 0 512.694 512.694",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m44.812 117.009c2.834 2.999 6.776 4.696 10.9 4.696h.066c4.147-.019 8.103-1.753 10.925-4.793l74.928-80.688c5.638-6.07 5.286-15.562-.784-21.199-6.07-5.638-15.562-5.285-21.198.785l-64.034 68.956-27.976-29.596c-5.689-6.021-15.184-6.289-21.204-.597-6.021 5.691-6.288 15.185-.597 21.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.812 296.93c2.834 2.998 6.776 4.696 10.9 4.696h.066c4.147-.019 8.103-1.753 10.925-4.793l74.929-80.688c5.637-6.071 5.285-15.562-.785-21.199-6.072-5.638-15.562-5.285-21.198.785l-64.033 68.956-27.977-29.596c-5.689-6.021-15.184-6.289-21.204-.597-6.021 5.691-6.288 15.185-.597 21.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.971 350.232c-41.891 0-75.971 34.08-75.971 75.97 3.819 100.646 148.136 100.619 151.941-.001-.001-41.889-34.081-75.969-75.97-75.969zm0 121.941c-25.349 0-45.971-20.622-45.971-45.97 2.311-60.901 89.639-60.886 91.94.001 0 25.347-20.622 45.969-45.969 45.969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.339 52.255h301.45c19.881-.738 19.866-29.269 0-30h-301.45c-19.881.737-19.866 29.269 0 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.339 110.467h203.963c19.881-.738 19.866-29.269 0-30h-203.963c-19.881.738-19.866 29.27 0 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.789 202.176h-301.45c-19.881.738-19.866 29.269 0 30h301.45c19.881-.738 19.866-29.27 0-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.339 290.388h203.963c19.881-.738 19.866-29.269 0-30h-203.963c-19.881.738-19.866 29.269 0 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.789 382.096h-301.45c-19.881.738-19.866 29.269 0 30h301.45c19.881-.738 19.866-29.269 0-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.302 440.309h-203.963c-19.881.738-19.866 29.269 0 30h203.963c19.881-.738 19.866-29.269 0-30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList2);
export default __webpack_public_path__ + "static/media/check-list-2.1339edfaebbba5a02e8fe57c47ff8d9e.svg";
export { ForwardRef as ReactComponent };